module.exports = __webpack_public_path__ + "static/media/Borrower.67f55d9e.svg";